import React, { useContext } from 'react';
import { CellWrapper } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  DeleteModal,
  getCurrentUserHook,
  getTranslatedText,
  useActivityTracker
} from '@nile/components';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { useIntl } from 'react-intl';
import { Tooltip } from 'react-clone-tippy';
import AssociateWorkItem from '@nile/components/src/Containers/NewWorklog/AssociateWorkItem';
import { Badge, Button, ButtonGroup } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty, pick } from 'lodash';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import WorklogTask from '@nile/components/src/Containers/NewWorklog/WorklogTask';

const WorkItemCellWrapper = styled.div`
  .Superops-Button {
    box-shadow: none !important;
  }
`;

const DisabledTag = styled.div`
  opacity: 0.6;
`;

const workItemTypeMap = {
  Ticket: 'TicketFilled',
  Project: 'ProjectFilled',
  TICKET: 'TicketFilled',
  PROJECT: 'ProjectFilled',
  TicketConversation: 'TicketFilled'
};

const WorkItemCell = (props) => {
  const { cell } = props;
  const timer = cell?.row?.original;
  const associatedTask = timer?.task;
  const tabContext = useContext(TicketContext);
  const { workItem } = timer;
  const { actions, editable } = cell?.column;
  const intl = useIntl();
  const flags = useFlags();
  const currentUser = getCurrentUserHook();
  const isLoggedinUser = timer?.technician.userId === currentUser?.userId;

  const handleAssociateWorkItem = (module, workItem) => {
    useActivityTracker({
      event:
        module === 'TICKET' ? 'Associated to ticket' : 'Associated to project'
    });
    return actions?.updateWorklogTimerEntry({
      variables: {
        timerEntryInput: {
          timerId: timer?.timerId,
          workItem: pick(workItem, ['workId', 'module'])
        }
      }
    });
  };

  const navigateToModule = () => {
    switch (workItem?.module) {
      case 'PROJECT':
        tabContext.openTab({
          projectId: workItem?.workId,
          module: 'PROJECT_DETAIL',
          data: {
            projectId: timer.workItem?.workId,
            title: timer.workItem?.title
          }
        });
        break;
      default:
        tabContext.openTab({
          ticketId: workItem.workId,
          module: 'TICKET',
          data: {
            subject: timer.workItem?.subject,
            //   displayId: timer.ticket?.displayId,
            ticketId: timer.workItem?.workId
          }
        });
        break;
    }
  };

  return (
    <div className="fx actr">
      {workItem ? (
        <div className="ellipsis">
          <CellWrapper onClick={navigateToModule} className="fx actr ptr">
            <span className="fx actr mr-10">
              <SVGIcon name={workItemTypeMap[workItem?.module]} />
            </span>
            <div className="ellipsis" title={workItem?.subject}>
              {workItem?.subject}
            </div>
          </CellWrapper>
          {!isEmpty(associatedTask) && (
            <div className="mt-5">
              <WorklogTask task={associatedTask} viewOnly />
            </div>
          )}
        </div>
      ) : editable && isLoggedinUser ? (
        <WorkItemCellWrapper>
          <ButtonGroup segmented>
            <DeleteModal
              modalActivator={
                <Button
                  icon={
                    <div id="delete-modal">
                      <SVGIcon name="Delete" color="#EC9E9E" />
                    </div>
                  }
                />
              }
              title={getTranslatedText(intl, 'timer.unknown.delete.title')}
              handleDeleteConfirmation={() => {
                actions?.deleteWorklogTimerEntry({
                  variables: {
                    deleteWorklogTimerInput: {
                      timerId: timer?.timerId
                    }
                  }
                });
              }}
              // handleDeleteConfirmation={handleDelete}
              description={getTranslatedText(
                intl,
                'timer.unknown.delete.description'
              )}
            />
            <AssociateWorkItem
              noPrefix
              timer={timer}
              handleAssociateWorkItem={handleAssociateWorkItem}
              triggerElement={
                <Tooltip
                  title={getTranslatedText(intl, 'timer.associate.to.workItem')}
                  delay={400}
                  duration={250}
                  position="top-start"
                  inertia
                  trigger="mouseenter"
                  animation="shift"
                  animateFill={false}
                >
                  <Button
                    icon={<SVGIcon name="RightArrowCircle" color="#4B8413" />}
                  />
                </Tooltip>
              }
            />
          </ButtonGroup>
        </WorkItemCellWrapper>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
      {timer?.worklogTimerType === 'MANUAL' && (
        <Tooltip
          title={getTranslatedText(intl, 'workItem.manual.entry')}
          delay={400}
          duration={250}
          position="top-start"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
        >
          <div className="mlauto f-12">
            <Badge status="attention">M</Badge>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default WorkItemCell;
